import { useRef, useEffect } from "react";
function useTimeouts() {
  const listRef = useRef([]);
  useEffect(
    () => () => {
      listRef.current.forEach((tid) => {
        clearTimeout(tid);
      });
    },
    []
  );
  return (callback, timeout) => {
    listRef.current.push(setTimeout(callback, timeout));
  };
}
export {
  useTimeouts
};
